(function () {
  function initLaborBenefits(root) {
    if (!root || root.dataset.initialized === 'true') return;

    const items = Array.from(root.querySelectorAll('[data-benefit-index]'));
    if (!items.length) return;
    const section = root.closest('.labor-benefits-showcase-section') || root;
    const sectionWrapper = root.closest('.shopify-section') || root;
    const previousModule = sectionWrapper.previousElementSibling;
    const previousLargeImage = previousModule
      ? previousModule.querySelector('.large-image-cont')
      : null;
    let nextModule = sectionWrapper.nextElementSibling;
    let nextEventSection = null;

    while (nextModule && !nextEventSection) {
      nextEventSection = nextModule.matches('.xmas-event-section.fathers-day-sale-section')
        ? nextModule
        : nextModule.querySelector('.xmas-event-section.fathers-day-sale-section');
      nextModule = nextModule.nextElementSibling;
    }

    root.dataset.initialized = 'true';
    const interval = Math.max(Number(root.dataset.mobileInterval) || 3000, 1000);
    const pageCount = Math.ceil(items.length / 2);
    let page = 0;
    let timer;
    let resizeObserver;
    let isMeasuring = false;
    let mobileStableOffset = 0;
    let lastSectionMarginTop = '';
    let lastSectionMarginBottom = '';
    let lastPreviousBottom = '';
    let lastNextPaddingTop = '';

    function isMobile() {
      return window.matchMedia('(max-width: 767px)').matches;
    }

    function applyVisiblePage(targetPage) {
      const pageSize = 2;

      items.forEach((item, index) => {
        const visible = !isMobile() || Math.floor(index / pageSize) === targetPage;
        item.classList.toggle('is-active', visible);
        item.setAttribute('aria-hidden', visible ? 'false' : 'true');
      });
    }

    function setStyleValue(element, property, value, cacheKey) {
      if (!element || cacheKey.value === value) return;
      element.style.setProperty(property, value);
      cacheKey.value = value;
    }

    function removeStyleValue(element, property, cacheKey) {
      if (!element || cacheKey.value === '') return;
      element.style.removeProperty(property);
      cacheKey.value = '';
    }

    function measureMobileStableOffset() {
      const card = root.querySelector('.labor-benefits-showcase__card');
      if (!card) return 0;

      isMeasuring = true;
      root.classList.add('is-measuring');
      card.style.removeProperty('--labor-benefits-showcase-card-min-height');

      let maxSectionHeight = 0;
      let maxCardHeight = 0;
      const currentPage = page;

      for (let index = 0; index < pageCount; index += 1) {
        page = index;
        applyVisiblePage(index);
        maxSectionHeight = Math.max(maxSectionHeight, section.getBoundingClientRect().height);
        maxCardHeight = Math.max(maxCardHeight, card.getBoundingClientRect().height);
      }

      page = currentPage;
      applyVisiblePage(page);

      if (maxCardHeight) {
        card.style.setProperty('--labor-benefits-showcase-card-min-height', `${Math.ceil(maxCardHeight)}px`);
      }

      root.classList.remove('is-measuring');
      isMeasuring = false;

      return maxSectionHeight ? Math.ceil(maxSectionHeight / 2) + 2 : 0;
    }

    function syncOffsets(forceMeasure) {
      if (isMeasuring) return;

      const offset = isMobile()
        ? (forceMeasure || !mobileStableOffset ? measureMobileStableOffset() : mobileStableOffset)
        : Math.ceil(section.getBoundingClientRect().height / 2) + 2;
      if (!offset) return;

      if (isMobile()) {
        mobileStableOffset = offset;
      }

      setStyleValue(section, '--labor-benefits-showcase-margin-top', `-${offset}px`, {
        get value() { return lastSectionMarginTop; },
        set value(nextValue) { lastSectionMarginTop = nextValue; }
      });
      setStyleValue(section, '--labor-benefits-showcase-margin-bottom', `-${offset}px`, {
        get value() { return lastSectionMarginBottom; },
        set value(nextValue) { lastSectionMarginBottom = nextValue; }
      });

      if (isMobile()) {
        if (previousLargeImage) {
          setStyleValue(previousLargeImage, 'bottom', `${offset + 50}px`, {
            get value() { return lastPreviousBottom; },
            set value(nextValue) { lastPreviousBottom = nextValue; }
          });
        }

        if (nextEventSection) {
          setStyleValue(nextEventSection, 'padding-top', `${offset + 50}px`, {
            get value() { return lastNextPaddingTop; },
            set value(nextValue) { lastNextPaddingTop = nextValue; }
          });
        }
      } else {
        if (previousLargeImage) {
          removeStyleValue(previousLargeImage, 'bottom', {
            get value() { return lastPreviousBottom; },
            set value(nextValue) { lastPreviousBottom = nextValue; }
          });
        }

        if (nextEventSection) {
          removeStyleValue(nextEventSection, 'padding-top', {
            get value() { return lastNextPaddingTop; },
            set value(nextValue) { lastNextPaddingTop = nextValue; }
          });
        }
      }
    }

    function render() {
      applyVisiblePage(page);
    }

    function restartTimer() {
      window.clearInterval(timer);
      if (!isMobile() || pageCount < 2) return;
      timer = window.setInterval(() => {
        page = (page + 1) % pageCount;
        render();
      }, interval);
    }

    render();
    syncOffsets(true);
    restartTimer();

    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(() => {
        if (!isMeasuring) syncOffsets();
      });
      resizeObserver.observe(root);
    }

    window.addEventListener('resize', () => {
      if (!isMobile()) page = 0;
      mobileStableOffset = 0;
      render();
      syncOffsets(true);
      restartTimer();
    });

    root.querySelectorAll('img').forEach((img) => {
      if (img.complete) return;
      img.addEventListener('load', () => syncOffsets(true), { once: true });
      img.addEventListener('error', () => syncOffsets(true), { once: true });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.labor-benefits-showcase').forEach(initLaborBenefits);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
